export default __webpack_public_path__ + "static/media/07.32cd45a9.jpg";